import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setMarketingAdsFilters } from '../../redux/actions/marketingAdsAction';
import CombinedAdsDashboard from './CombinedAdsDashboard';
import GoogleAdsDashboard from './GoogleAdsDashboard';
import MetaAdsDashboard from './MetaAdsDashboard';

export default function MarketingLeadsPage({ initial = 'both' }) {
    const dispatch = useDispatch();
    const savedChannel = useSelector((state) => state.marketingAds?.filters?.channel);
    const [channel, setChannel] = useState(() => {
        if (initial === 'google') return 'google';
        if (initial === 'meta') return 'meta';
        if (savedChannel === 'google' || savedChannel === 'meta' || savedChannel === 'both') {
            return savedChannel;
        }
        return 'both';
    });

    useEffect(() => {
        dispatch(setMarketingAdsFilters({ channel }));
    }, [channel, dispatch]);
    if (channel === 'google') {
        return <GoogleAdsDashboard channel="google" onChannel={setChannel} />;
    }
    if (channel === 'both') {
        return <CombinedAdsDashboard channel="both" onChannel={setChannel} />;
    }
    return <MetaAdsDashboard channel="meta" onChannel={setChannel} />;
}

export function MetaMarketingPage() {
    return <MarketingLeadsPage initial="both" />;
}

export function GoogleMarketingPage() {
    return <MarketingLeadsPage initial="google" />;
}
